// Global ref for ActiveIndicatorsModal
// This allows ChartTooltips to access the modal without prop drilling
export const activeIndicatorsModalRef = { current: null };
